import { Callout } from '@/components/notifications/Callout/Callout';

export function EmoneySyncedFieldsCallout() {
  return (
    <Callout severity="info-low">
      Disabled fields below are synced to eMoney and cannot be edited in
      Luminary
    </Callout>
  );
}
